import { useEffect, useRef, useState } from 'react';
import { get } from './api';

export interface StudentPick { id: number; label: string }
interface StudentRow { id: number; name: string; className: string; unit: string }
const UNIT: Record<string, string> = { H: 'Meninos', M: 'Meninas', I: 'Infantil', A: 'Atibaia' };

/**
 * Busca de aluno(a) no banco de alunos (pedido de reserva: tutoria e pais e responsáveis).
 * Digita parte do nome e escolhe na lista: nome, turma e unidade.
 */
export function StudentPicker({ id, value, onChange }: { id: string; value: StudentPick | null; onChange: (s: StudentPick | null) => void }) {
  const [q, setQ] = useState('');
  const [list, setList] = useState<StudentRow[]>([]);
  const [open, setOpen] = useState(false);
  const seq = useRef(0);
  useEffect(() => {
    const term = q.trim();
    if (term.length < 3) { setList([]); return; }
    const my = ++seq.current;
    const t = window.setTimeout(() => {
      get<StudentRow[]>('students/search?q=' + encodeURIComponent(term))
        .then(r => { if (my === seq.current) { setList(r); setOpen(true); } }).catch(() => undefined);
    }, 250);
    return () => window.clearTimeout(t);
  }, [q]);
  const label = (s: StudentRow) => `${s.name} · ${s.className} · ${UNIT[s.unit] ?? s.unit}`;
  if (value) return (
    <div className="qroom"><div className="top"><div><b>{value.label}</b></div>
      <button type="button" className="btn ghost sm" onClick={() => onChange(null)}>Trocar</button></div></div>
  );
  return (
    <div className="people-add">
      <div className="suggestions">
        <input type="text" id={id} value={q} placeholder="Digite parte do nome do aluno(a)" autoComplete="off" aria-autocomplete="list" aria-expanded={open && list.length > 0}
          onChange={e => setQ(e.target.value)} onFocus={() => list.length && setOpen(true)} onBlur={() => window.setTimeout(() => setOpen(false), 150)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); if (list[0]) { onChange({ id: list[0].id, label: label(list[0]) }); setQ(''); } } }} />
        {open && list.length > 0 && (
          <ul className="ac-list" role="listbox">
            {list.map(s => (
              <li key={s.id}><button type="button" onMouseDown={e => e.preventDefault()} onClick={() => { onChange({ id: s.id, label: label(s) }); setQ(''); setOpen(false); }}>
                {s.name}<small>{s.className} · {UNIT[s.unit] ?? s.unit}</small></button></li>
            ))}
          </ul>
        )}
        {open && q.trim().length >= 3 && !list.length && <span className="hint">Nenhum aluno(a) com esse nome.</span>}
      </div>
    </div>
  );
}
